import { oneSignalMutations } from "../mutation-types";

export default {
	namespaced: true,

	state: {
		idDevice: null
	},

	actions: {
		updateIdDevice( { commit }, callback ) {
			const oneSignal = window.OneSignal || [];

			oneSignal.push( () => {
				const idDeviceGetter = oneSignal.getUserId();

				idDeviceGetter.then( idDevice => commit( oneSignalMutations.SET_ID_DEVICE, idDevice ) );
				idDeviceGetter.then( callback );
			} );
		}
	},

	mutations: {
		[oneSignalMutations.SET_ID_DEVICE]( store, id ) {
			store.idDevice = id;
		}
	}
};
